import angular from 'angular';

SearchLegacyController.$inject = ['loggedUser', 'company', '$scope', '$state', 'SearchSelectorsFactory', 'selectorsData'];
export function SearchLegacyController(loggedUser, company, $scope, $state, SearchSelectorsFactory, selectorsData) {

  $scope.setAppliedSelectorsValues = setAppliedSelectorsValues;
  $scope.removeAll = removeAll;
  $scope.createParameters = createParameters;
  init();

  function createMessageSelectors() {
    let selectors = [];

    selectors.push(SearchSelectorsFactory.createReceptionDate());
    selectors.push(SearchSelectorsFactory.createAccountsAndChannelsSelector(loggedUser.capabilities));
    selectors.push(SearchSelectorsFactory.createStatusSelector());
    selectors.push(SearchSelectorsFactory.createMessageAuthorSelector());
    selectors.push(SearchSelectorsFactory.createMessageContentSelector());
    selectors = selectors.concat(SearchSelectorsFactory.createTagsSelectors(company));

    return selectors;
  }

  function createActionSelectors() {
    let selectors = [];

    selectors.push(SearchSelectorsFactory.createActionDateSelector());
    selectors.push(SearchSelectorsFactory.createActionTypeSelector());
    selectors.push(SearchSelectorsFactory.createActionAuthorSelector(selectorsData.admin_users));

    return selectors;
  }

  function setAppliedSelectorsValues(selector) {
    selector.setAppliedValues();
    createParameters();
    selector.isOpen = false;
  }

  function removeAll() {
    for (let sel of $scope.allSelectors) {
      sel.remove();
    }
  }

  function createParameters() {
    let parameters = {};
    for (let selector of $scope.allSelectors) {
      selector.save();
      let paramsFragment = selector.createParametersFragment(parameters);
      angular.extend(parameters, paramsFragment);
    }

    if (angular.equals(parameters, {})) {
      $scope.hasSelectedParams = false;
      return;
    }

    $scope.hasSelectedParams = true;
    // Automatic parameter to scope our research to the sites with capabilities...
    let sites = SearchSelectorsFactory.getSitesWithSearchCapability(loggedUser.capabilities);
    parameters.sites_ids = sites.map(s => s.id);

    if (!$state.includes('**.process')) { // copied/pasted URLs should work even if we have some old search config in our local storage
      $state.go('auth.alcmeon.search-legacy.tasks', { parameters: parameters });
    }
  }

  function init() {
    $scope.$state = $state;
    $scope.hasSelectedParams = true;
    $scope.messageCriteriaSelectors = createMessageSelectors();
    $scope.actionCriteriaSelectors = createActionSelectors();
    $scope.allSelectors = $scope.messageCriteriaSelectors.concat($scope.actionCriteriaSelectors);
    for (let selector of $scope.allSelectors) {
      selector.load();
    }
    createParameters();
  }
}

